import {
  React,
  Component,
  axios,
  routes,
  PropTypes,
  helpers,
} from 'imports/CommonImports';

import {
  GreyColor2,
  GreyColor1,
  PrimaryButton,
} from 'imports/DesignImports';

import {
  DoneIcon
} from 'imports/IconsImports';

import ReactHighcharts from 'react-highcharts';

import {
  TextField,
  Paper,
  LinearProgress,
} from 'material-ui';


const styles = {
  pageContainer: {
    padding: '1em',
    display: 'flex',
  },
  textField: {
    width: 'auto',
    display: 'flex',
    justifyContent: 'center',
    borderBottom: '1px solid',
    borderColor: GreyColor1,
    margin: '0 0.5em',
  },
  textFieldInput: {
    textAlign: 'center',
  },
  textFieldUnderline: {
    width: 'auto',
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '3em',
  },
  button: {
    marginTop: '1em'
  }
}

class SockGraphPlusTable extends Component {
  constructor(props){
    super(props);
    this.state = {
      years: this.props.years,
      goal: this.props.data.goal_per_year.map(value => value.value),
    }
  }

  render() {
    return (
      <Paper style={{...styles.pageContainer, ...this.props.style}}>
        {/* <img src={dashboard} alt="Índice i3" style={{maxWidth:"100%"}} /> */}
        <div style={{flex: 1, borderRight: '1px solid', borderColor: GreyColor1, paddingLeft: '2em'}}>
          <p style={styles.header}><b>{this.props.header}</b></p>
          <ReactHighcharts config={this.config(this.state.goal)} ref="chart"></ReactHighcharts>
        </div>
        <div style={{flex: 1, padding: '0 1em'}}>
          <p style={styles.header}><b>Definir meta de {this.props.data.indicator} ({this.props.data.currency})</b></p>
          <div style={{ width: "100%" }}>
            <div style={{ overflowX: 'auto'}}>  
            <table style={{ minWidth: "700px" }}>
              <thead>
                <th></th>
                {this.state.years.map(year => <th>{year}</th> )}
              </thead>
              <tbody>
              <tr>
                <th style={{width: "25%"}}></th>
                {this.props.data.goal_per_year.map(value => {
                  return <th key={value.id} style={{width: "25%"}}><h3>{value.year}</h3></th>
                })}
              </tr>
              <tr>
                <td><h3>Business as usual</h3></td>
                {this.props.data.BAU_per_year.map((value, i) => {
                  return <td key={value.id} style={{textAlign: "center"}}>{helpers.numberWithDots(value.value)}</td>
                })}
              </tr>
              <tr>
                <td><h3>Innovación</h3></td>
                  {this.props.data.innovation_per_year.map((value, i) => {
                    return <td key={i} style={{textAlign: "center"}}>{helpers.numberWithDots(value.value)}</td>
                  })}
              </tr>
              <tr>
                <td><h3>Meta</h3></td>
                  {this.props.data.goal_per_year.map((value, i) => {
                    return (
                      <td key={value.id} style={{textAlign: "center"}}>
                        <TextField
                          hintText={(new Date(value.date)).getFullYear()}
                          underlineStyle={styles.textFieldUnderline}
                          value={helpers.numberWithDots(this.state.goal[i])}
                          onChange={(event, newValue) => {this.handleChange(event, newValue, i)}}
                          inputStyle={styles.textFieldInput}
                          style={styles.textField}/>
                      </td>
                    );
                  })}
              </tr>
              </tbody>
            </table>
            </div>
          </div>
          <div style={styles.buttonContainer}>
            {this.state.sendState === 'SENDING' && <LinearProgress style={{width: '60%'}}/>}
            {this.state.sendState === 'SUCCESS' && <div style={{display: 'flex', alignItems: 'center'}}>Meta guardada <DoneIcon/></div>}
            {this.state.sendState === 'ERROR' && <div>Error, intente de nuevo</div>}
            <PrimaryButton onClick={this.saveGoal} label="Guardar meta" style={styles.button}/>
          </div>
        </div>
      </Paper>
    );
  }

  saveGoal = () => {
    this.setState({sendState: 'SENDING'})
    var connection = axios.create({
      baseURL: routes.host,
      headers: {'Authorization': "Token "+ this.props.token}
    });
    var data = {
      companyInfo: this.props.data.goal_per_year.map((goal, i) => {
        return {id: goal.id, goalValue: this.state.goal[i], BAUValue: this.props.data.BAU_per_year[i].value}
      })
    }
    connection.patch(routes.companyIndexInfo(this.props.user.company_id), data)
    .then((response) => {
      this.setState({sendState: 'SUCCESS'})
    })
    .catch((error) => {
      this.setState({sendState: 'ERROR'})
      console.error(error);
    })
  }

  handleChange = (event, newValue, index) => {
    var goal = this.state.goal;
    if(newValue === '')
      goal[index] = 0;
    else
      goal[index] = parseFloat(helpers.numberWithoutDots(newValue));
    this.setState({goal: goal});
  }

  config = (goal) => { return({
    chart: {
        type: 'column',
        width: 500,
        backgroundColor: GreyColor2,
    },
    title: {
      text: ''
    },
    xAxis: {
        categories: this.state.years
    },
    yAxis: {
        min: 0,
        title: {
            text: this.props.data.indicator + '(MM ' + this.props.data.currency + ')',
        },
        stackLabels: {
            enabled: true,
            style: {
                fontWeight: 'bold',
                color: (ReactHighcharts.theme && ReactHighcharts.theme.textColor) || 'gray'
            }
        }
    },
    legend: {
        align: 'center',
        x: 0,
        verticalAlign: 'top',
        y: 0,
        floating: true,
        backgroundColor: (ReactHighcharts.theme && ReactHighcharts.theme.background2) || 'white',
        borderColor: '#CCC',
        borderWidth: 1,
        shadow: false
    },
    tooltip: {
        headerFormat: '<b>{point.x}</b><br/>',
        pointFormat: '{series.name}: {point.y}<br/>Total: {point.stackTotal}'
    },
    plotOptions: {
        column: {
            stacking: 'normal',
            dataLabels: {
                enabled: true,
                color: (ReactHighcharts.theme && ReactHighcharts.theme.dataLabelsColor) || 'white'
            },
            events: {
              legendItemClick: function () {
                  return false;
              }
          }
        },
        allowPointSelect: false
    },
    series: [{
        name: 'Extra',
        data: this.state.goal.map(value => parseFloat((value / 1000000).toFixed(2))),
        color: '#11AB99'
    }, {
        name: 'Innovación',
        data: this.props.data.innovation_per_year.map(value => parseFloat((value.value / 1000000).toFixed(2))),
        color: '#1A2644'
    }, {
        name: 'BAU',
        data: this.props.data.BAU_per_year.map(value => parseFloat((value.value / 1000000).toFixed(2))),
        color: '#A4A9B4'
    }],
    credits: {
      enabled: false
    }
  })}
}

SockGraphPlusTable.propTypes = {
  data: PropTypes.object,
  style: PropTypes.object,
  goal: PropTypes.array,
};

SockGraphPlusTable.defaultProps = {
  data: {
    currency: '',
    indicator: '',
    goal_per_year: [
      {date: '2017-01-01', value: 0},
      {date: '2018-01-01', value: 0},
      {date: '2019-01-01', value: 0},
    ],
    innovation_per_year: [
        {date: '2017-01-01', value: 0},
        {date: '2018-01-01', value: 0},
        {date: '2019-01-01', value: 0},
    ],
    BAU_per_year: [
        {date: '2017-01-01', value: 0},
        {date: '2018-01-01', value: 0},
        {date: '2019-01-01', value: 0},
    ]
  },
  style: {},
  goal: [0, 0, 0]
};

export default SockGraphPlusTable;



// WEBPACK FOOTER //
// ./src/components/dashboard/SockGraphPlusTable.js